import {
  GET_TEAM_REQUEST,
  GET_TEAM_SUCCESS,
  GET_TEAM_FAILURE,
} from 'redux-api/action/actionTypes';

const initialState = {
  payload: {},
  error: '',
  isGetWaiting: true,
  loaded: false,
};

export default function teams(state = initialState, action) {
  switch (action.type) {
    case GET_TEAM_REQUEST:
      return {
        ...state,
        isGetWaiting: true,
      };
    case GET_TEAM_SUCCESS:
      return {
        ...state,
        payload: action.payload || {},
        error: '',
        isGetWaiting: false,
        loaded: true,
      };
    case GET_TEAM_FAILURE:
      return {
        ...state,
        error: action.error,
        isGetWaiting: false,
        loaded: true,
      };
    default:
      return state;
  }
}
